import { createRouter, createWebHistory } from 'vue-router'

// 定义 Vue Router 管理的路由路径
const vueRoutes = [
  '/',
  '/words',
  '/phrases',
  '/irregular',
  '/dictation',
  '/dictation-chinese',
  // '/wrong-words',
  '/quiz',
  // '/settings',
  // '/question-bank-editor',
]

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/words'
    },
    {
      path: '/words',
      name: 'words',
      component: () => import('../views/WordsPage.vue')
    },
    {
      path: '/phrases',
      name: 'phrases',
      component: () => import('../views/PhrasePage.vue')
    },
    {
      path: '/irregular',
      name: 'irregular',
      component: () => import('../views/IrregularPage.vue')
    },
    {
      path: '/dictation',
      name: 'dictation',
      component: () => import('../views/DictationPage.vue'),
      meta: { mode: 'english' }
    },
    {
      path: '/dictation-chinese',
      name: 'dictationChinese',
      component: () => import('../views/DictationPage.vue'),
      meta: { mode: 'chinese' }
    },
    // {
    //   path: '/wrong-words',
    //   name: 'wrongWords',
    //   component: () => import('../views/WrongWordsPage.vue')
    // },
    {
      path: '/quiz',
      name: 'quiz',
      component: () => import('../views/QuizPage.vue')
    },
    // {
    //   path: '/settings',
    //   name: 'settings',
    //   component: () => import('../views/SettingsPage.vue')
    // },
    // {
    //   path: '/question-bank-editor',
    //   name: 'questionBankEditor',
    //   component: () => import('../views/QuestionBankEditor.vue')
    // }
  ]
})

// 导航守卫：阻止 Vue Router 处理非 Vue 路由
router.beforeEach((to, _from, next) => {
  // 检查目标路径是否在 Vue 路由列表中
  if (vueRoutes.includes(to.path)) {
    next() // 继续 Vue Router 导航
  } else {
    // 不是 Vue 路由，阻止导航并返回 false
    // 这样可以避免警告，同时不会触发页面刷新
    return false
  }
})

export default router
